import React, { ChangeEvent, FormEvent, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMoneyBills, faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons"
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api"
import "./Pagos.css"
import { env } from "./environments/env/environment.prod"

export const LoginPago = () => {
	return <iframe src={env.new_proc_url} className="w-full h-[81vh]" />
}

const mapStyles = {
	height: "200px",
	width: "100%",
}

const defaultCenter = {
	lat: 19.224806,
	lng: -70.532088,
}

export function Payment() {
	const [selectedFiles, setSelectedFiles] = useState<FileList | null>(null)

	const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
		setSelectedFiles(event.target.files)
	}

	const deleteFiles = () => {
		setSelectedFiles(null)
	}

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault()

		if (selectedFiles) {
			const formData = new FormData()

			Array.from(selectedFiles).forEach((file) => {
				const uniqueName = `${Date.now()}_${file.name}` // Generar nombre único
				formData.append("files", file, uniqueName)
			})

			formData.append("to", "carlosepjorge@gmail.com") // Correo de destino

			try {
				await fetch("/api/documents", {
					method: "POST",
					body: formData,
				})

				console.log("Archivos enviados correctamente")

				deleteFiles()
			} catch (error) {
				console.error("Error al enviar los archivos:", error)
			}
		}
	}

	return (
		<div>
			<h1 className="text-center text-blue-800">Puntos de pago</h1>
			<div className="payment-container">
				<div className="payment-card">
					<div className="icon-text">
						<FontAwesomeIcon icon={faMoneyBills} size="2x" color="#2c5282" />
						<h3 className="text-left text-blue-800">Caja Ayuntamiento</h3>
					</div>
					<p>C/ Don Antonio Guzmán # 419, Frente al Parque Duarte,</p>
					<p>Concepción de La Vega, La Vega, R.D.</p>
					<br />
					{/* <LoadScript googleMapsApiKey="AIzaSyA7Uv3tKCaMzfuuus0zPv59WVMbF-Iodwc">
						<GoogleMap mapContainerStyle={mapStyles} zoom={20} center={defaultCenter}>
							<Marker position={defaultCenter} />
						</GoogleMap>
					</LoadScript> */}
				</div>
				<div className="payment-card">
					<div className="icon-text">
						<FontAwesomeIcon icon={faMoneyBillTransfer} size="2x" color="#2c5282" />
						<h3 className="text-center text-blue-800">Transferencia bancaria</h3>
					</div>
					<p>
						<b>Cta. Corriente 0502073233</b>
					</p>
					<p>Rnc: 4-03-00029-1</p>
					<p>
						Enviar comprobante WS: <a href="https://wa.me/8296797270">(829) 679-7270</a> o
						cargarlo mediante el Bot del portal
					</p>
					{/* <form onSubmit={handleSubmit}>
						<input type="file" multiple onChange={handleFileUpload} />
						<button type="submit">Enviar</button>
					</form> */}
				</div>
			</div>
		</div>
	)
}
